export const rootPath = '/';
export const onboardingWelcomePath = '/onboarding/welcome';
export const onboardingCategorySelectionPath = '/onboarding/category-selection';
export const questCreatePath = '/quests/create/:categoryId?';
export const questEditPath = '/quests/edit/:id';
export const postponeEditPath = '/quests/postpone/edit';
export const questViewPath = '/quests/view/:id';
export const rewardCreatePath = '/rewards/create';
export const rewardEditPath = '/rewards/edit/:id';
export const rewardViewPath = '/rewards/view/:id';
export const achievementViewPath = '/achievements/view/:id';
export const achievementEditPath = '/achievements/edit/:id';
export const achievementCreatePath = '/achievements/create/:categoryId?';
export const goalsCompletedPath = '/goals/completed';
export const completedAchievementsPath = '/completed-achievements';
export const goalsConfigurePath = '/goals/configure';
export const goalsViewPath = '/goals/view';
export const goalsSelectPath = '/goals/select';
export const focusModePath = '/focus-mode/:questId';
export const categoryPath = '/categories/:categoryId';
export const categoryCreatePath = '/categories/create';
export const categoryEditPath = '/categories/edit/:categoryId';
export const achievementsTabPath = '/achievements';
export const achievementCategoryPath = '/achievements/category/:categoryId';
export const categoriesListTabPath = '/categories';
export const profileTabPath = '/profile';
export const languagePath = '/profile/settings';
export const activityPath = '/activity';
export const rewardsPath = '/rewards';
export const questTemplatesPath = '/quests/templates';
export const questTemplateConfigPath = '/quests/templates/config/:templateId';
export const todayQuestProgressPath = '/quests/today-progress';
export const ritualViewPath = '/rituals/view/:id';
export const ritualEditPath = '/rituals/edit/:ritualType';
export const ritualTaskEditPath = '/rituals/task/:ritualType/:taskIndex?';
export const journalTabPath = '/journal';
export const journalEntryPath = '/journal/entry/:ritualId?/:journalEntryId?';
export const ratingEntryPath = '/rating/entry/:ritualId?/:ratingEntryId?';
export const oauthApprovalPath = '/oauth/:sessionId/:clientId';
export const voiceCommandsDocsPath = '/voice/commands';
export const premiumPath = '/premium';
